import {Injectable} from '@angular/core';
import {ApiService} from './';
import {Observable} from 'rxjs';
import {EventType} from '../models/event-type';

@Injectable()
export class TypeEventService {

  constructor(private apiService: ApiService) {}

  list(): Observable<EventType[]> {
    return this.apiService.get('/event_types');
  }
}
